import * as React from "react";
import { useEffect, useState, useContext, useRef } from "react";
import {
  DataGrid,
  GridColumns,
  GridColumnVisibilityModel,
  GridRenderCellParams,
} from "@mui/x-data-grid";

import Contrato from "../../components/classes/Contrato";
import ContratoItem from "../../components/classes/ContratoItem";
import UnidadeArmazenamento from "../../components/classes/UnidadeArmazenamento";

import ContratoItemDataset from "../../components/data/ContratoItemDataSet";
import ContratoDataset from "../../components/data/ContratoDataSet";
import UnidadeArmazenamentoDataset from "../../components/data/UnidadeArmazenamentoDataSet";
import { hasInCache } from "../../helper/cacheHelper";

import Button from "@mui/material/Button";

import IconButton from "@mui/material/IconButton";
import EraseIcon from "@mui/icons-material/Delete";
import AppsIcon from "@mui/icons-material/Apps";
import ReplayIcon from "@mui/icons-material/Replay";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LockResetIcon from "@mui/icons-material/LockReset";
import LockIcon from "@mui/icons-material/Lock";

/* Alert */
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";

/* Dialog */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/* LOCALIZAÇÃO */
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tooltip,
} from "@mui/material";
import ForecastDataset from "../../components/data/ForecastDataSet";
import PageHelper from "../../helper/pageHelper";
import { confirmAlert } from "react-confirm-alert";
import SkuDescricao from "../../components/common/SkuDescricao";
import { UserContext } from "../../App";

import styles from "./detail.module.css";
import DialogSapHistory, {
  HandleDialogSAPHistory,
} from "./components/DialogSapHistory";
import Projeto from "../../components/classes/Projeto";
import ProjetoDataset from "../../components/data/ProjetoDataSet";
import ModalOrigens from "./modals/ModalOrigens";

import { useTranslation } from "react-i18next";

export interface Data {
  id: number;
  idSKU: number;
  descricaoSKU: string;
  centro: number;
  anoRef: number;
  quantidade: number;
  codigoFornecedorSap: Number;
  numeroContrato: string;
  gerouForecast: boolean;
  contratoSap: string;
  projeto: string;
  origem: string;
  delete: boolean;
}

interface RowProps extends GridRenderCellParams<Data> {
  row: Data;
}
interface RowCommited {
  id: string | number;
  value?: number | string;
  field: string;
}
interface ActionsOfCellEdit {
  [key: string]: (params: RowCommited) => Promise<void>;
}

function createData(
  id: number,
  idSKU: number,
  descricaoSKU: string,
  centro: number,
  anoRef: number,
  quantidade: number,
  codigoFornecedorSap: Number,
  numeroContrato: string,
  gerouForecast: boolean,
  contratoSap: string,
  del: boolean,
  projeto = "",
  origem = ""
): Data {
  return {
    id,
    idSKU,
    descricaoSKU,
    centro,
    anoRef,
    quantidade,
    codigoFornecedorSap,
    numeroContrato,
    gerouForecast,
    contratoSap,
    projeto,
    origem,
    delete: del,
  };
}

const ContratoItemGrid = () => {
  const { t } = useTranslation();
  const user: any = useContext(UserContext);
  const [openMsg, setOpenMsg] = useState(true);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [contrato, setContrato] = useState<Contrato>({} as Contrato);
  const [contratosItem, setContratosItens] = useState<ContratoItem[]>([]);
  const [projeto, setProjeto] = useState<String>("");
  const [projetos, setProjetos] = useState<Projeto[]>([]);

  const [excluiItem, setExcluiItem] = useState(false);
  const [itemToExcluir, setItemExcluir] = useState<ContratoItem>(
    new ContratoItem()
  );
  const [itemAbrirOrigens, setItemAbrirOrigens] = useState<number>(0);

  const [rows, setRows] = useState<Data[]>([]);
  const [mensagem, setMensagem] = useState("");
  const [severity, setSeverity] = useState(0);

  const dataContratoItem: ContratoItemDataset = new ContratoItemDataset();
  const dataContrato: ContratoDataset = new ContratoDataset();
  const dataSKU: UnidadeArmazenamentoDataset =
    new UnidadeArmazenamentoDataset();
  const dataForecast: ForecastDataset = new ForecastDataset();
  const dataProjeto: ProjetoDataset = new ProjetoDataset();

  const [open, setOpen] = useState(false);
  const [openOrigens, setOpenOrigens] = useState(false);
  const dialogSapHistoryRef = useRef<HandleDialogSAPHistory | null>(null);

  useEffect(() => {
    dataProjeto.ListarAtivos().then((projetos) => {
      if (projetos) setProjetos(projetos);
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    let _contrato: Contrato = new Contrato();
    if (hasInCache(dataContrato.getKeyCacheClass())) {
      _contrato = dataContrato.RecuperarObjetoDoCache();
      setContrato(_contrato);
      dataContratoItem
        .ListarAtivos(
          String(_contrato.numeroContrato),
          Number(_contrato.codigoFornecedorSAP)
        )
        .then((result) => {
          setContratosItens(result);
          preencherGrid(result);
          var _gerou: boolean = false;
          result.map((item: ContratoItem) => {
            if (item.gerouForecast) _gerou = true;
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [refresh]);

  useEffect(() => {
    if (excluiItem === true) {
      dataContratoItem
        .Apagar(itemToExcluir)
        .then((response) => {
          if (response) {
            Mensagem(
              t("common.delete"),
              t("pages.contracts.text.contractItemUpdateWithSuccess")
            );
          } else {
            Mensagem(
              t("common.delete"),
              t("pages.contracts.text.contractItemDeleteError")
            );
          }
        })
        .catch((erro) => {
          Mensagem(
            t("common.delete"),
            t("pages.contracts.text.contractItemDeleteError")
          );
        });
      // setMensagem("Item do Contrato Excluido com sucesso!")
      // setSeverity(0);
    }
    setExcluiItem(false);
    setItemExcluir(new ContratoItem());
    setRefresh(!refresh);
  }, [excluiItem]);

  const getColumns = (): GridColumns => {
    return [
      {
        field: "id",
        headerName: "#",
        type: "string",
        width: 70,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "idSKU",
        headerName: t("common.skuCode"),
        type: "number",
        width: 120,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "descricaoSKU",
        headerName: t("common.skuDescription.label"),
        type: "string",
        minWidth: 300,
        flex: 2,
        headerAlign: "center",
        align: "left",
        renderCell: (params: any) => <SkuDescricao value={params.value} />,
      },
      {
        field: "centro",
        headerName: t("common.center"),
        type: "string",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "projeto",
        headerName: t("common.project"),
        minWidth: 120,
        headerAlign: "center",
        align: "center",
        editable: true,
        renderEditCell: renderEditCellProjeto,
      },
      {
        field: "anoRef",
        headerName: t("pages.contracts.text.yearReference"),
        type: "number",
        width: 100,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params: any) => round3(params.value),
      },
      {
        field: "quantidade",
        headerName: t("common.quantity"),
        type: "number",
        width: 120,
        headerAlign: "center",
        align: "right",
        valueFormatter: (params: any) => round3(params.value) + " Kg",
      },
      {
        field: "actions",
        headerName: t("common.actions"),
        width: 250,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (params: any) => (
          <React.Fragment>
            <Tooltip title={t("pages.contracts.text.generateMonthlyForecast")}>
              <span>
                <IconButton
                  disabled={
                    params.row.gerouForecast ||
                    user.isParceiro ||
                    user.isSuporte
                  }
                  onClick={() => {
                    if (!params.row.gerouForecast) {
                      handleConfimation(
                        t("pages.contracts.text.monthlyForecats"),
                        t("pages.contracts.text.monthlyForecatsContinue"),
                        params
                      );
                    }
                  }}
                >
                  {" "}
                  <AppsIcon />{" "}
                </IconButton>
              </span>
            </Tooltip>
            {params.row.gerouForecast && (
              <Tooltip title={t("pages.contracts.text.reverseForecast")}>
                <span>
                  <IconButton
                    disabled={
                      !params.row.gerouForecast ||
                      user.isParceiro ||
                      user.isSuporte
                    }
                    onClick={() => {
                      if (params.row.gerouForecast) {
                        handleConfimationEstornar(
                          t("pages.contracts.text.reverseForecast"),
                          t("pages.contracts.text.reverseForecastProceed"),
                          params
                        );
                      }
                    }}
                  >
                    <ReplayIcon />
                  </IconButton>
                </span>
              </Tooltip>
            )}
            {!params.row.gerouForecast && (
              <Tooltip title={t("pages.contracts.text.removeItem")}>
                <span>
                  <IconButton
                    disabled={
                      params.row.gerouForecast ||
                      user.isParceiro ||
                      user.isSuporte
                    }
                    onClick={() => {
                      //const actualItem = dataContratoItem.ListarFromCache().find(f => f.id === params.row.id)
                      const actualItem = contratosItem.find(
                        (f) => f.id === params.row.id
                      );

                      if (actualItem) {
                        setItemExcluir(actualItem);
                        handleClickOpen();
                      }
                    }}
                  >
                    {" "}
                    <EraseIcon />
                  </IconButton>
                </span>
              </Tooltip>
            )}
            {/* {!(user.isParceiro || user.isSuporte) && (
                            <Tooltip title="Histórico">
                                <IconButton onClick={() => {
                                    handleOpenHistoryOfSap(params);
                                }}> <ManageSearchIcon /> </IconButton>
                            </Tooltip>
                        )} */}
            {!(user.isParceiro || user.isSuporte) && (
              <Tooltip title={t("common.origins")}>
                <IconButton
                  onClick={() => {
                    handleOpenOrigem(params.row.id);
                  }}
                >
                  {" "}
                  <LocalShippingIcon />{" "}
                </IconButton>
              </Tooltip>
            )}
            {(user.isPlanejamentoBRF || user.isRoot) &&
              params.row.delete == false && (
                <Tooltip title={t("pages.contracts.text.blockStuff")}>
                  <IconButton
                    onClick={() => {
                      handleToggleMaterial(params.row.id);
                    }}
                  >
                    {" "}
                    <LockIcon />{" "}
                  </IconButton>
                </Tooltip>
              )}
            {(user.isPlanejamentoBRF || user.isRoot) &&
              params.row.delete == true && (
                <Tooltip title={t("pages.contracts.text.unblockStuff")}>
                  <IconButton
                    onClick={() => {
                      handleToggleMaterial(params.row.id);
                    }}
                  >
                    {" "}
                    <LockResetIcon />{" "}
                  </IconButton>
                </Tooltip>
              )}
          </React.Fragment>
        ),
      },
    ];
  };

  const handleToggleMaterial = async (id: number) => {
    try {
      await dataContratoItem.Toggle(id);
      Mensagem(
        t("pages.contracts.text.contractItem"),
        t("pages.contracts.text.itemUpdateWithSuccess"),
        true
      );
    } catch (err) {
      console.log(err);
    }
  };

  const renderEditCellProjeto = () => {
    return (
      <FormControl fullWidth>
        <InputLabel id="selectprojetoitem">
          {t("pages.contracts.text.project")}
        </InputLabel>
        <Select
          labelId="selectprojetoitem"
          id="selectprojetoitem"
          value={projeto}
          label={t("pages.contracts.text.project")}
          onChange={(e) => {
            setProjeto(e.target.value);
          }}
        >
          {projetos.map((projeto) => (
            <MenuItem key={+projeto.id} value={projeto.nome}>
              {projeto.nome}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const closeAlert = (refresh: boolean) => {
    setOpen(false);
    if (refresh) {
      PageHelper.refreshPage();
    }
  };

  const Mensagem = (
    titulo: string,
    mensagem: string,
    refresh: boolean = true
  ) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            closeAlert(refresh);
          },
        },
      ],
      onClickOutside: () => {
        closeAlert(refresh);
      },
    });
  };

  const handleConfimation = (
    titulo: string,
    mensagem: string,
    cellValues: any
  ) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.yes"),
          onClick: async () => {
            setOpen(false);
            gerarForecast(cellValues);
          },
        },
        {
          label: t("common.no"),
          onClick: () => {
            setOpen(false);
          },
        },
      ],
    });
  };

  const handleConfimationEstornar = (
    titulo: string,
    mensagem: string,
    cellValues: any
  ) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.yes"),
          onClick: async () => {
            setOpen(false);
            estornar(cellValues);
          },
        },
        {
          label: t("common.no"),
          onClick: () => {
            setOpen(false);
          },
        },
      ],
    });
  };

  const estornar = (cellValues: any) => {
    dataForecast
      .Estornar(buscarContrato(contrato, cellValues.row.id, contratosItem))
      .then((result) => {
        if (result) {
          Mensagem(
            t("common.warning"),
            `${t("pages.contracts.text.reverseForecastSuccess")} \n\r`
          );
        } else {
          Mensagem(
            t("common.error"),
            `${t("pages.contracts.text.reverseForecastUnsuccessful")} \n\r`
          );
        }
      });
  };

  const gerarForecast = (cellValues: any) => {
    cellValues.row.gerouForecast = true;
    setLoading(true);
    const contratoTemp = buscarContrato(
      contrato,
      cellValues.row.id,
      contratosItem
    );
    dataForecast
      .DetalharAno(contratoTemp)
      .then((response) => {
        if (response) {
          Mensagem(
            t("pages.contracts.text.generateMonthlyForecast"),
            `${t("pages.contracts.text.contractForecast")}: ${
              contrato.numeroContrato
            } ${t("pages.contracts.text.forPartner")} ${contrato.grupo} ${t(
              "pages.contracts.text.andSku"
            )} ${cellValues.row.idSKU} ${t(
              "pages.contracts.text.generatedWithSuccess"
            )}`
          );
        }
      })
      .catch(() => {
        // setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const round3 = (value: number) => {
    return value ? stripZeros(value.toFixed(3)) : 0;
  };

  const stripZeros = (str: string) => {
    return parseFloat(str.replace(",", ".")).toString().replace(".", ",");
  };

  const GetSKUName = (_idSKU: number): string => {
    let nome: string = "";
    try {
      let objeto: UnidadeArmazenamento = dataSKU
        .ListarFromCache()
        .filter((f) => f.idSKU === _idSKU)[0];
      nome = objeto.descricao;
    } catch (error) {}
    return nome;
  };

  const onCellEditCommit = async (value: string, field: string, id: number) => {
    var row = rows.find((x) => +x.id == +id);
    var originalItem = contratosItem.find((i) => +i.id === +id);

    if (row && originalItem) {
      switch (field) {
        case "origem":
          row.origem = value?.toString() ?? "";
          break;
        case "contratoSap":
          row.contratoSap = value?.toString() ?? "";
          break;
        case "projeto":
          row.projeto = projeto.toString();
          break;
      }

      var newRows = [...rows.filter((x) => x.id != id), row];
      setRows(newRows.sort((a, b) => a.id - b.id));

      originalItem.origem = row.origem;
      originalItem.contratoSap = row.contratoSap;
      originalItem.projeto = row.projeto;

      await dataContratoItem.Atualizar(originalItem);
    }
  };

  const handleOpenHistoryOfSap = React.useCallback((params: RowProps) => {
    console.log(params);
    dialogSapHistoryRef.current?.item(String(params.row.id));
  }, []);

  const handleOpenOrigem = (id: number) => {
    setOpenOrigens(true);
    setItemAbrirOrigens(id);
  };

  const preencherGrid = (_itens: ContratoItem[]) => {
    setRows(
      _itens.map((_contratoItem: ContratoItem) => {
        return createData(
          Number(_contratoItem.id),
          Number(_contratoItem.idSku),
          GetSKUName(Number(_contratoItem.idSku)),
          Number(_contratoItem.centroDistribuicaoDestino),
          Number(_contratoItem.anoRef),
          Number(_contratoItem.quantidade),
          _contratoItem.codigoFornecedorSap,
          _contratoItem.numeroContrato,
          _contratoItem.gerouForecast,
          _contratoItem.contratoSap,
          _contratoItem.d_E_L_E_T_E,
          _contratoItem.projeto,
          _contratoItem.origem
        );
      })
    );
    setLoading(false);
  };

  const buscarContrato = (
    contrato: Contrato,
    id: Number,
    contratosItem: ContratoItem[]
  ) => {
    const contratoTemp = contrato;
    if (contrato.itensContrato) {
      if (contrato.itensContrato.length > 0) {
        contratoTemp.itensContrato = contrato.itensContrato.filter(
          (f) => f.id === id
        );
        if (contratoTemp.itensContrato.length === 0) {
          contratoTemp.itensContrato = contratosItem.filter((f) => f.id === id);
        }
      } else if (contratosItem.length > 0) {
        contratoTemp.itensContrato = contratosItem.filter((f) => f.id === id);
      }
    }
    return contratoTemp;
  };

  const TransitionAlerts = (_severity: number, _mensagem: string) => {
    return (
      <Box
        className="divAlert"
        sx={{
          width: "50%",
          position: "absolute",
          zIndex: "1000",
          left: "25%",
          top: "30%",
        }}
      >
        <Collapse in={openMsg}>
          <Alert
            severity={
              _severity === 0
                ? "success"
                : _severity === 1
                ? "info"
                : _severity === 2
                ? "warning"
                : "error"
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpenMsg(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {_mensagem}
          </Alert>
        </Collapse>
      </Box>
    );
  };

  return (
    <>
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("pages.contracts.text.excludeItemQuestionTitle2")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("pages.contracts.text.excludeItemQuestionSubTitle2")}
              <br />
              <br />
              {t("common.skuId")}:{" "}
              <strong>
                {itemToExcluir.idSku}
                <strong />
              </strong>
              <br />
              {t("common.center")}:{" "}
              <strong>{itemToExcluir.centroDistribuicaoDestino}</strong>
              <br />
              {t("common.description")}:{" "}
              <strong>
                {GetSKUName(Number.parseInt(String(itemToExcluir.idSku)))}
              </strong>
              <br />
              <br />
              {t("pages.contracts.text.excludeItemQuestionConfirmation2")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              onClick={() => {
                setExcluiItem(true);
                handleClose();
              }}
            >
              {t("common.yes")}
            </Button>
            <Button
              variant="outlined"
              color="success"
              onClick={handleClose}
              autoFocus
            >
              {t("common.no")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div className={styles.table}>
        <DataGrid
          loading={loading}
          rows={rows}
          columns={getColumns()}
          key="ContratoItemGrid"
          rowHeight={32}
          rowsPerPageOptions={[50, 100, 250, 500]}
          onCellEditCommit={(e) => onCellEditCommit(e.value, e.field, +e.id)}
          onCellEditStart={(e) => setProjeto(e.row.projeto)}
        />
        {mensagem.length > 0 ? TransitionAlerts(severity, mensagem) : null}
      </div>

      <DialogSapHistory ref={dialogSapHistoryRef} />

      <ModalOrigens
        openOrigens={openOrigens}
        setOpenOrigens={setOpenOrigens}
        itemContratoId={itemAbrirOrigens}
        openModal={handleOpenHistoryOfSap}
      />
    </>
  );
};

export default ContratoItemGrid;
